/**
 * Registro y gestión del Service Worker
 */

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  window.location.hostname === '[::1]' ||
  window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

export function register(config) {
  if ('serviceWorker' in navigator) {
    // Esperar a que la página cargue completamente
    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      if (isLocalhost) {
        // En localhost, verificar si el SW existe
        checkValidServiceWorker(swUrl, config);
        navigator.serviceWorker.ready.then(() => {
          console.log('[SW] Esta app está siendo servida con cache-first por un service worker.');
        });
      } else {
        // En producción, registrar el SW directamente
        registerValidSW(swUrl, config);
      }
    });
  }
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      console.log('[SW] Service Worker registrado:', registration);

      // Verificar actualizaciones periódicamente
      setInterval(() => {
        registration.update();
      }, 300000); // Cada 5 minutos

      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }

        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // Nuevo contenido disponible
              console.log('[SW] Nueva versión disponible. Actualiza para obtener el contenido más reciente.');

              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }

              // Mostrar notificación al usuario
              if (window.confirm('¡Hay una nueva versión disponible! ¿Deseas actualizar ahora?')) {
                installingWorker.postMessage({ type: 'SKIP_WAITING' });
                // El reload lo maneja el listener controllerchange
              }
            } else {
              // Contenido cacheado para uso offline
              console.log('[SW] Contenido cacheado para uso offline.');

              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };
    })
    .catch((error) => {
      console.error('[SW] Error durante el registro del Service Worker:', error);
    });

  // Escuchar mensajes del SW
  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data && event.data.type === 'SW_UPDATED') {
      console.log('[SW] Mensaje del SW:', event.data.message);
    }
  });

  // Recargar cuando el SW tome control
  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!refreshing) {
      refreshing = true;
      window.location.reload();
    }
  });
}

function checkValidServiceWorker(swUrl, config) {
  // Verificar si el service worker existe
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' },
  })
    .then((response) => {
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        // No se encontró el SW, recargar la página
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        // SW encontrado, proceder con el registro
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log('[SW] No hay conexión a internet. La app está corriendo en modo offline.');
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}

// Función helper para limpiar el cache
export function clearCache() {
  if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
    navigator.serviceWorker.controller.postMessage({ type: 'CLEAR_CACHE' });
  }
}
